import API from 'api/hallomart';

/**
 * Constants
 */

export const FETCH_PRODUCTS = 'products/FETCH_PRODUCTS';
export const FETCH_PRODUCTS_OK = 'products/FETCH_PRODUCTS_OK';
export const FETCH_PRODUCTS_FAILED = 'products/FETCH_PRODUCTS_FAILED';


/**
 * Action Creators
 */

export function fetchProducts() {
	return async (dispatch) => {
		try {
			dispatch({ type: FETCH_PRODUCTS });
			const products = await API.getMerchantProducts();
			dispatch({ type: FETCH_PRODUCTS_OK, products: products.data });
		} catch (err) {
			dispatch({ type: FETCH_PRODUCTS_FAILED, error: err.response || err.message });
		}
	};
}


/**
 * Reducers
 */

const initialState = {
	isLoading: false,
	error: false,
	errors: {},
	products: [],
	isLoaded: false
};

export default function products(state = initialState, action) {
	switch (action.type) {
		case FETCH_PRODUCTS:
			return {
				...state,
				error: false,
				errors: {},
				isLoading: true
			};

		case FETCH_PRODUCTS_OK:
			return {
				...state,
				isLoading: false,
				isLoaded: true,
				products: action.products
			};

		case FETCH_PRODUCTS_FAILED:
			return {
				...state,
				isLoading: false,
				error: true,
				errors: action.error
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/modules/products.js